window.ttx = window.ttx || {};

ttx.history = {
    /**
     * 历史记录命令业务封装：
     * 1. 拉取历史版本列表
     * 2. 优先调用当前页签缓存的 openHistoryPreview
     * 3. 兜底走页签级/全局事件广播打开运行时浮层
     */
    open: function (ctx) {
        const vm = ctx?.vm;
        if (!vm) {
            ttx.toast?.error?.('历史记录命令缺少 vm 上下文');
            return Promise.resolve(false);
        }

        const billno = vm.getParams?.()?.billno || vm.getParams?.()?.billNo || vm.getDiworkCode?.() || '';
        const id = vm.getParams?.()?.id || vm.getParams?.()?.params?.id || vm.getData?.()?.id;
        if (!billno || !id) {
            ttx.toast?.warning?.('当前单据缺少历史记录查询参数');
            return Promise.resolve(false);
        }

        const load = ttx.loading?.showInCurrentTab?.();
        return new Promise(function (resolve) {
            const query = ttx.utils.transferQuery({ billno: billno, id: id });
            ttx.ajax.xhrUtil({
                url: '/api/bill/history' + query,
                method: 'get',
                success: function (res) {
                    load?.hide?.();
                    const result = res?.data || res || {};
                    const versions = result.versions || result.list || [];
                    const detail = {
                        title: result.title || '变更历史记录',
                        subtitle: result.subtitle || vm._get_data?.('template')?.view?.cCaption || '',
                        versions: versions,
                        selectedVersion: versions[0] || null,
                        paneIndex: vm.getCache?.('paneIndex'),
                        // 卡片本身以模态框打开时，历史记录也要以弹窗形式挂载，否则会被卡片弹窗盖住
                        modal: !!vm.getCache?.('__isModal'),
                        // 模态框卡片的 vm 没有挂 Meta，父页面用它定位弹窗自身的 metaData/vm 来渲染历史预览
                        viewModel: vm,
                    };

                    const openHistoryPreview = vm.getCache?.('openHistoryPreview');
                    if (typeof openHistoryPreview === 'function') {
                        openHistoryPreview(detail);
                    } else {
                        const event = new CustomEvent('ttx:history:open', { detail: detail });
                        const container = document.querySelector('.metaRunnerContainer');
                        container?.dispatchEvent?.(event);
                        document.dispatchEvent(event);
                    }
                    resolve(true);
                },
                fail: function (err) {
                    load?.hide?.();
                    ttx.utils.alert(err?.message || '历史记录加载失败', 'error');
                    resolve(false);
                }
            });
        });
    }
};
